export default __webpack_public_path__ + "static/media/2.489b0ba0.png";